import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 4h6v6h-6z","key":"svg-0"}],["path",{"d":"M4 14h6v6h-6z","key":"svg-1"}],["path",{"d":"M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-2"}],["path",{"d":"M7 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-3"}]]

const IconCategory2 = createReactComponent('outline', 'category-2', 'Category2', __iconNode);

export default IconCategory2;